import styled from '@emotion/styled';
import { Palette } from 'config';

const LineSeparator = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  height: 1px;
  background-color: ${Palette.PrimaryGray._200};
  width: 964px;
  margin-left: -40px;
`;

const Separator = ({ width, marginLeft, marginTop, style }) => {
  return (
    <LineSeparator
      style={{ width: width, marginLeft: marginLeft, marginTop: marginTop, ...style }}
    />
  );
};

export default Separator;
